type ProfileTranslation = {
  title: string;
  subtitle: string;
  photo_title: string;
  photo_description: string;
  upload_photo: string;
  uploading_photo: string;
  remove_photo_aria: string;
  photo_hint: string;
  personal_title: string;
  personal_description: string;
  first_name: string;
  last_name: string;
  email_address: string;
  email_hint: string;
  phone_number: string;
  save_changes: string;
  saving_changes: string;
  security_prompt: string;
  go_to_security: string;
  toast_profile_updated: string;
  toast_avatar_updated: string;
  toast_avatar_removed: string;
  toast_security_navigation: string;
  error_first_last_required: string;
  error_profile_update: string;
  error_avatar_upload: string;
  error_avatar_remove: string;
  error_avatar_process: string;
  error_image_type: string;
  error_image_size: string;
  error_image_read: string;
  crop_title: string;
  crop_description: string;
  crop_zoom_label: string;
  crop_reset: string;
  crop_tip: string;
  crop_cancel: string;
  crop_apply: string;
  user_fallback: string;
};

export const profileTranslations: Record<string, ProfileTranslation> = {
  pt: {
    title: "Perfil",
    subtitle: "Gere as tuas informações pessoais e preferências",
    photo_title: "Foto",
    photo_description: "Atualiza a tua foto de perfil",
    upload_photo: "Carregar foto",
    uploading_photo: "A carregar...",
    remove_photo_aria: "Remover foto",
    photo_hint: "JPG, PNG ou GIF. Tamanho máx. 2MB.",
    personal_title: "Informações pessoais",
    personal_description: "Atualiza os teus dados pessoais",
    first_name: "Nome",
    last_name: "Apelido",
    email_address: "Endereço de email",
    email_hint: "Altera o email em Definições > Segurança.",
    phone_number: "Número de telefone",
    save_changes: "Guardar alterações",
    saving_changes: "A guardar...",
    security_prompt: "Precisas de alterar a password, gerir contas ligadas ou ativar a autenticação de dois fatores?",
    go_to_security: "Ir para Segurança",
    toast_profile_updated: "Perfil atualizado com sucesso",
    toast_avatar_updated: "Avatar atualizado com sucesso",
    toast_avatar_removed: "Avatar removido com sucesso",
    toast_security_navigation: "Vai a Definições > Segurança para gerir as tuas definições de segurança",
    error_first_last_required: "O nome e o apelido são obrigatórios.",
    error_profile_update: "Não foi possível atualizar o perfil.",
    error_avatar_upload: "Não foi possível carregar o avatar.",
    error_avatar_remove: "Não foi possível remover o avatar.",
    error_avatar_process: "Não foi possível processar o avatar.",
    error_image_type: "Seleciona um ficheiro de imagem.",
    error_image_size: "A imagem deve ter menos de 2MB.",
    error_image_read: "Não foi possível ler a imagem.",
    crop_title: "Ajustar imagem",
    crop_description: "Recorta e ajusta a imagem para ficar perfeita.",
    crop_zoom_label: "Zoom",
    crop_reset: "Repor",
    crop_tip: "Dica: Usa o slider para fazer zoom (10% - 500%). Arrasta a imagem para reposicionar. A imagem será guardada como avatar circular.",
    crop_cancel: "Cancelar",
    crop_apply: "Aplicar",
    user_fallback: "Utilizador",
  },
  en: {
    title: "Profile",
    subtitle: "Manage your personal information and preferences",
    photo_title: "Photo",
    photo_description: "Update your profile photo",
    upload_photo: "Upload photo",
    uploading_photo: "Uploading...",
    remove_photo_aria: "Remove photo",
    photo_hint: "JPG, PNG or GIF. Max size 2MB.",
    personal_title: "Personal Information",
    personal_description: "Update your personal details",
    first_name: "First Name",
    last_name: "Last Name",
    email_address: "Email Address",
    email_hint: "Change your email in Settings > Security.",
    phone_number: "Phone Number",
    save_changes: "Save Changes",
    saving_changes: "Saving...",
    security_prompt: "Need to change your password, manage connected accounts, or enable two-factor authentication?",
    go_to_security: "Go to Security Settings",
    toast_profile_updated: "Profile updated successfully",
    toast_avatar_updated: "Avatar updated successfully",
    toast_avatar_removed: "Avatar removed successfully",
    toast_security_navigation: "Navigate to Settings > Security to manage your security settings",
    error_first_last_required: "First name and last name are required.",
    error_profile_update: "Unable to update profile.",
    error_avatar_upload: "Unable to upload avatar.",
    error_avatar_remove: "Unable to remove avatar.",
    error_avatar_process: "Unable to process avatar.",
    error_image_type: "Please select an image file.",
    error_image_size: "Image must be smaller than 2MB.",
    error_image_read: "Unable to read the image.",
    crop_title: "Adjust Image",
    crop_description: "Crop and adjust the image to fit perfectly.",
    crop_zoom_label: "Zoom",
    crop_reset: "Reset",
    crop_tip: "Tip: Use the slider to zoom in/out (10% - 500%). Drag the image freely to reposition. The image will be saved as a circular avatar.",
    crop_cancel: "Cancel",
    crop_apply: "Apply",
    user_fallback: "User",
  },
  es: {
    title: "Perfil",
    subtitle: "Gestiona tu información personal y preferencias",
    photo_title: "Foto",
    photo_description: "Actualiza tu foto de perfil",
    upload_photo: "Subir foto",
    uploading_photo: "Subiendo...",
    remove_photo_aria: "Eliminar foto",
    photo_hint: "JPG, PNG o GIF. Tamaño máx. 2MB.",
    personal_title: "Información personal",
    personal_description: "Actualiza tus datos personales",
    first_name: "Nombre",
    last_name: "Apellidos",
    email_address: "Correo electrónico",
    email_hint: "Cambia tu correo en Configuración > Seguridad.",
    phone_number: "Número de teléfono",
    save_changes: "Guardar cambios",
    saving_changes: "Guardando...",
    security_prompt: "¿Necesitas cambiar tu contraseña, gestionar cuentas conectadas o activar la autenticación de dos factores?",
    go_to_security: "Ir a Seguridad",
    toast_profile_updated: "Perfil actualizado correctamente",
    toast_avatar_updated: "Avatar actualizado correctamente",
    toast_avatar_removed: "Avatar eliminado correctamente",
    toast_security_navigation: "Ve a Configuración > Seguridad para gestionar tus opciones de seguridad",
    error_first_last_required: "El nombre y los apellidos son obligatorios.",
    error_profile_update: "No se pudo actualizar el perfil.",
    error_avatar_upload: "No se pudo subir el avatar.",
    error_avatar_remove: "No se pudo eliminar el avatar.",
    error_avatar_process: "No se pudo procesar el avatar.",
    error_image_type: "Selecciona un archivo de imagen.",
    error_image_size: "La imagen debe ser menor de 2MB.",
    error_image_read: "No se pudo leer la imagen.",
    crop_title: "Ajustar imagen",
    crop_description: "Recorta y ajusta la imagen para que encaje perfectamente.",
    crop_zoom_label: "Zoom",
    crop_reset: "Restablecer",
    crop_tip: "Consejo: Usa el control deslizante para hacer zoom (10% - 500%). Arrastra la imagen para reposicionarla. La imagen se guardará como avatar circular.",
    crop_cancel: "Cancelar",
    crop_apply: "Aplicar",
    user_fallback: "Usuario",
  },
  et: {
    title: "Profiil",
    subtitle: "Halda oma isiklikku teavet ja eelistusi",
    photo_title: "Foto",
    photo_description: "Uuenda oma profiilipilti",
    upload_photo: "Laadi foto üles",
    uploading_photo: "Laadimine...",
    remove_photo_aria: "Eemalda foto",
    photo_hint: "JPG, PNG või GIF. Maks. suurus 2MB.",
    personal_title: "Isiklik teave",
    personal_description: "Uuenda oma isikuandmeid",
    first_name: "Eesnimi",
    last_name: "Perekonnanimi",
    email_address: "E-posti aadress",
    email_hint: "Muuda e-posti Seadetes > Turvalisus.",
    phone_number: "Telefoninumber",
    save_changes: "Salvesta muudatused",
    saving_changes: "Salvestamine...",
    security_prompt: "Kas soovid muuta parooli, hallata ühendatud kontosid või lubada kaheastmelise autentimise?",
    go_to_security: "Ava turvaseaded",
    toast_profile_updated: "Profiil edukalt uuendatud",
    toast_avatar_updated: "Avatar edukalt uuendatud",
    toast_avatar_removed: "Avatar edukalt eemaldatud",
    toast_security_navigation: "Ava Seaded > Turvalisus, et hallata turvaseadeid",
    error_first_last_required: "Eesnimi ja perekonnanimi on kohustuslikud.",
    error_profile_update: "Profiili uuendamine ebaõnnestus.",
    error_avatar_upload: "Avatari üleslaadimine ebaõnnestus.",
    error_avatar_remove: "Avatari eemaldamine ebaõnnestus.",
    error_avatar_process: "Avatari töötlemine ebaõnnestus.",
    error_image_type: "Palun vali pildifail.",
    error_image_size: "Pilt peab olema väiksem kui 2MB.",
    error_image_read: "Pildi lugemine ebaõnnestus.",
    crop_title: "Kohanda pilti",
    crop_description: "Lõika ja kohanda pilt, et see sobituks.",
    crop_zoom_label: "Suum",
    crop_reset: "Lähtesta",
    crop_tip: "Nipp: Kasuta liugurit suumimiseks (10% - 500%). Lohista pilti ümberpaigutamiseks. Pilt salvestatakse ringikujulise avatarina.",
    crop_cancel: "Tühista",
    crop_apply: "Rakenda",
    user_fallback: "Kasutaja",
  },
  de: {
    title: "Profil",
    subtitle: "Verwalten Sie Ihre persönlichen Informationen und Einstellungen",
    photo_title: "Foto",
    photo_description: "Profilfoto aktualisieren",
    upload_photo: "Foto hochladen",
    uploading_photo: "Wird hochgeladen...",
    remove_photo_aria: "Foto entfernen",
    photo_hint: "JPG, PNG oder GIF. Max. Größe 2MB.",
    personal_title: "Persönliche Informationen",
    personal_description: "Aktualisieren Sie Ihre persönlichen Daten",
    first_name: "Vorname",
    last_name: "Nachname",
    email_address: "E-Mail-Adresse",
    email_hint: "Ändern Sie Ihre E-Mail unter Einstellungen > Sicherheit.",
    phone_number: "Telefonnummer",
    save_changes: "Änderungen speichern",
    saving_changes: "Wird gespeichert...",
    security_prompt: "Möchten Sie Ihr Passwort ändern, verbundene Konten verwalten oder die Zwei-Faktor-Authentifizierung aktivieren?",
    go_to_security: "Zu den Sicherheitseinstellungen",
    toast_profile_updated: "Profil erfolgreich aktualisiert",
    toast_avatar_updated: "Avatar erfolgreich aktualisiert",
    toast_avatar_removed: "Avatar erfolgreich entfernt",
    toast_security_navigation: "Navigieren Sie zu Einstellungen > Sicherheit, um Ihre Sicherheitseinstellungen zu verwalten",
    error_first_last_required: "Vorname und Nachname sind erforderlich.",
    error_profile_update: "Profil konnte nicht aktualisiert werden.",
    error_avatar_upload: "Avatar konnte nicht hochgeladen werden.",
    error_avatar_remove: "Avatar konnte nicht entfernt werden.",
    error_avatar_process: "Avatar konnte nicht verarbeitet werden.",
    error_image_type: "Bitte wählen Sie eine Bilddatei aus.",
    error_image_size: "Das Bild muss kleiner als 2MB sein.",
    error_image_read: "Bild konnte nicht gelesen werden.",
    crop_title: "Bild anpassen",
    crop_description: "Schneiden Sie das Bild zu und passen Sie es an.",
    crop_zoom_label: "Zoom",
    crop_reset: "Zurücksetzen",
    crop_tip: "Tipp: Verwenden Sie den Schieberegler zum Zoomen (10% - 500%). Ziehen Sie das Bild, um es zu positionieren. Das Bild wird als runder Avatar gespeichert.",
    crop_cancel: "Abbrechen",
    crop_apply: "Übernehmen",
    user_fallback: "Benutzer",
  },
  fr: {
    title: "Profil",
    subtitle: "Gérez vos informations personnelles et préférences",
    photo_title: "Photo",
    photo_description: "Mettez à jour votre photo de profil",
    upload_photo: "Téléverser une photo",
    uploading_photo: "Téléversement...",
    remove_photo_aria: "Supprimer la photo",
    photo_hint: "JPG, PNG ou GIF. Taille max. 2Mo.",
    personal_title: "Informations personnelles",
    personal_description: "Mettez à jour vos informations personnelles",
    first_name: "Prénom",
    last_name: "Nom",
    email_address: "Adresse e-mail",
    email_hint: "Modifiez votre e-mail dans Paramètres > Sécurité.",
    phone_number: "Numéro de téléphone",
    save_changes: "Enregistrer les modifications",
    saving_changes: "Enregistrement...",
    security_prompt: "Besoin de changer votre mot de passe, gérer les comptes connectés ou activer l’authentification à deux facteurs ?",
    go_to_security: "Aller aux paramètres de sécurité",
    toast_profile_updated: "Profil mis à jour avec succès",
    toast_avatar_updated: "Avatar mis à jour avec succès",
    toast_avatar_removed: "Avatar supprimé avec succès",
    toast_security_navigation: "Allez dans Paramètres > Sécurité pour gérer vos paramètres de sécurité",
    error_first_last_required: "Le prénom et le nom sont obligatoires.",
    error_profile_update: "Impossible de mettre à jour le profil.",
    error_avatar_upload: "Impossible de téléverser l’avatar.",
    error_avatar_remove: "Impossible de supprimer l’avatar.",
    error_avatar_process: "Impossible de traiter l’avatar.",
    error_image_type: "Veuillez sélectionner un fichier image.",
    error_image_size: "L’image doit faire moins de 2 Mo.",
    error_image_read: "Impossible de lire l’image.",
    crop_title: "Ajuster l’image",
    crop_description: "Recadrez et ajustez l’image pour qu’elle s’adapte parfaitement.",
    crop_zoom_label: "Zoom",
    crop_reset: "Réinitialiser",
    crop_tip: "Astuce : utilisez le curseur pour zoomer (10% - 500%). Faites glisser l’image pour la repositionner. L’image sera enregistrée en avatar circulaire.",
    crop_cancel: "Annuler",
    crop_apply: "Appliquer",
    user_fallback: "Utilisateur",
  },
  it: {
    title: "Profilo",
    subtitle: "Gestisci le tue informazioni personali e preferenze",
    photo_title: "Foto",
    photo_description: "Aggiorna la tua foto profilo",
    upload_photo: "Carica foto",
    uploading_photo: "Caricamento...",
    remove_photo_aria: "Rimuovi foto",
    photo_hint: "JPG, PNG o GIF. Dimensione max 2MB.",
    personal_title: "Informazioni personali",
    personal_description: "Aggiorna i tuoi dati personali",
    first_name: "Nome",
    last_name: "Cognome",
    email_address: "Indirizzo email",
    email_hint: "Modifica l'email in Impostazioni > Sicurezza.",
    phone_number: "Numero di telefono",
    save_changes: "Salva modifiche",
    saving_changes: "Salvataggio...",
    security_prompt: "Devi cambiare password, gestire account collegati o attivare l’autenticazione a due fattori?",
    go_to_security: "Vai alle impostazioni di sicurezza",
    toast_profile_updated: "Profilo aggiornato con successo",
    toast_avatar_updated: "Avatar aggiornato con successo",
    toast_avatar_removed: "Avatar rimosso con successo",
    toast_security_navigation: "Vai a Impostazioni > Sicurezza per gestire le impostazioni di sicurezza",
    error_first_last_required: "Nome e cognome sono obbligatori.",
    error_profile_update: "Impossibile aggiornare il profilo.",
    error_avatar_upload: "Impossibile caricare l’avatar.",
    error_avatar_remove: "Impossibile rimuovere l’avatar.",
    error_avatar_process: "Impossibile elaborare l’avatar.",
    error_image_type: "Seleziona un file immagine.",
    error_image_size: "L'immagine deve essere inferiore a 2MB.",
    error_image_read: "Impossibile leggere l'immagine.",
    crop_title: "Regola immagine",
    crop_description: "Ritaglia e regola l'immagine per adattarla perfettamente.",
    crop_zoom_label: "Zoom",
    crop_reset: "Reimposta",
    crop_tip: "Suggerimento: usa il cursore per lo zoom (10% - 500%). Trascina l'immagine per riposizionarla. L'immagine verrà salvata come avatar circolare.",
    crop_cancel: "Annulla",
    crop_apply: "Applica",
    user_fallback: "Utente",
  },
  nl: {
    title: "Profiel",
    subtitle: "Beheer je persoonlijke informatie en voorkeuren",
    photo_title: "Foto",
    photo_description: "Werk je profielfoto bij",
    upload_photo: "Foto uploaden",
    uploading_photo: "Bezig met uploaden...",
    remove_photo_aria: "Foto verwijderen",
    photo_hint: "JPG, PNG of GIF. Max. grootte 2MB.",
    personal_title: "Persoonlijke informatie",
    personal_description: "Werk je persoonlijke gegevens bij",
    first_name: "Voornaam",
    last_name: "Achternaam",
    email_address: "E-mailadres",
    email_hint: "Wijzig je e-mail in Instellingen > Beveiliging.",
    phone_number: "Telefoonnummer",
    save_changes: "Wijzigingen opslaan",
    saving_changes: "Opslaan...",
    security_prompt: "Wil je je wachtwoord wijzigen, verbonden accounts beheren of tweefactorauthenticatie inschakelen?",
    go_to_security: "Ga naar Beveiligingsinstellingen",
    toast_profile_updated: "Profiel succesvol bijgewerkt",
    toast_avatar_updated: "Avatar succesvol bijgewerkt",
    toast_avatar_removed: "Avatar succesvol verwijderd",
    toast_security_navigation: "Ga naar Instellingen > Beveiliging om je beveiligingsinstellingen te beheren",
    error_first_last_required: "Voornaam en achternaam zijn verplicht.",
    error_profile_update: "Kan profiel niet bijwerken.",
    error_avatar_upload: "Kan avatar niet uploaden.",
    error_avatar_remove: "Kan avatar niet verwijderen.",
    error_avatar_process: "Kan avatar niet verwerken.",
    error_image_type: "Selecteer een afbeeldingsbestand.",
    error_image_size: "De afbeelding moet kleiner zijn dan 2MB.",
    error_image_read: "Kan de afbeelding niet lezen.",
    crop_title: "Afbeelding aanpassen",
    crop_description: "Snijd bij en pas de afbeelding aan zodat deze perfect past.",
    crop_zoom_label: "Zoom",
    crop_reset: "Reset",
    crop_tip: "Tip: Gebruik de schuifregelaar om te zoomen (10% - 500%). Sleep de afbeelding om te verplaatsen. De afbeelding wordt opgeslagen als ronde avatar.",
    crop_cancel: "Annuleren",
    crop_apply: "Toepassen",
    user_fallback: "Gebruiker",
  },
  sv: {
    title: "Profil",
    subtitle: "Hantera din personliga information och dina preferenser",
    photo_title: "Foto",
    photo_description: "Uppdatera din profilbild",
    upload_photo: "Ladda upp foto",
    uploading_photo: "Laddar upp...",
    remove_photo_aria: "Ta bort foto",
    photo_hint: "JPG, PNG eller GIF. Maxstorlek 2MB.",
    personal_title: "Personlig information",
    personal_description: "Uppdatera dina personuppgifter",
    first_name: "Förnamn",
    last_name: "Efternamn",
    email_address: "E-postadress",
    email_hint: "Ändra din e-post i Inställningar > Säkerhet.",
    phone_number: "Telefonnummer",
    save_changes: "Spara ändringar",
    saving_changes: "Sparar...",
    security_prompt: "Behöver du ändra ditt lösenord, hantera anslutna konton eller aktivera tvåfaktorsautentisering?",
    go_to_security: "Gå till säkerhetsinställningar",
    toast_profile_updated: "Profil uppdaterad",
    toast_avatar_updated: "Avatar uppdaterad",
    toast_avatar_removed: "Avatar borttagen",
    toast_security_navigation: "Gå till Inställningar > Säkerhet för att hantera säkerhetsinställningar",
    error_first_last_required: "Förnamn och efternamn krävs.",
    error_profile_update: "Kunde inte uppdatera profilen.",
    error_avatar_upload: "Kunde inte ladda upp avataren.",
    error_avatar_remove: "Kunde inte ta bort avataren.",
    error_avatar_process: "Kunde inte bearbeta avataren.",
    error_image_type: "Välj en bildfil.",
    error_image_size: "Bilden måste vara mindre än 2MB.",
    error_image_read: "Kunde inte läsa bilden.",
    crop_title: "Justera bild",
    crop_description: "Beskär och justera bilden så att den passar perfekt.",
    crop_zoom_label: "Zoom",
    crop_reset: "Återställ",
    crop_tip: "Tips: Använd reglaget för att zooma (10% - 500%). Dra bilden för att flytta den. Bilden sparas som en cirkulär avatar.",
    crop_cancel: "Avbryt",
    crop_apply: "Använd",
    user_fallback: "Användare",
  },
  da: {
    title: "Profil",
    subtitle: "Administrer dine personlige oplysninger og præferencer",
    photo_title: "Foto",
    photo_description: "Opdater dit profilfoto",
    upload_photo: "Upload foto",
    uploading_photo: "Uploader...",
    remove_photo_aria: "Fjern foto",
    photo_hint: "JPG, PNG eller GIF. Maks. størrelse 2MB.",
    personal_title: "Personlige oplysninger",
    personal_description: "Opdater dine personlige oplysninger",
    first_name: "Fornavn",
    last_name: "Efternavn",
    email_address: "E-mailadresse",
    email_hint: "Skift din e-mail i Indstillinger > Sikkerhed.",
    phone_number: "Telefonnummer",
    save_changes: "Gem ændringer",
    saving_changes: "Gemmer...",
    security_prompt: "Skal du ændre din adgangskode, administrere tilknyttede konti eller aktivere tofaktorgodkendelse?",
    go_to_security: "Gå til sikkerhedsindstillinger",
    toast_profile_updated: "Profil opdateret",
    toast_avatar_updated: "Avatar opdateret",
    toast_avatar_removed: "Avatar fjernet",
    toast_security_navigation: "Gå til Indstillinger > Sikkerhed for at administrere dine sikkerhedsindstillinger",
    error_first_last_required: "Fornavn og efternavn er påkrævet.",
    error_profile_update: "Kunne ikke opdatere profilen.",
    error_avatar_upload: "Kunne ikke uploade avatar.",
    error_avatar_remove: "Kunne ikke fjerne avatar.",
    error_avatar_process: "Kunne ikke behandle avatar.",
    error_image_type: "Vælg en billedfil.",
    error_image_size: "Billedet skal være mindre end 2MB.",
    error_image_read: "Kunne ikke læse billedet.",
    crop_title: "Juster billede",
    crop_description: "Beskær og juster billedet, så det passer perfekt.",
    crop_zoom_label: "Zoom",
    crop_reset: "Nulstil",
    crop_tip: "Tip: Brug skyderen til at zoome (10% - 500%). Træk billedet for at flytte det. Billedet gemmes som en cirkulær avatar.",
    crop_cancel: "Annuller",
    crop_apply: "Anvend",
    user_fallback: "Bruger",
  },
  fi: {
    title: "Profiili",
    subtitle: "Hallitse henkilökohtaisia tietojasi ja asetuksia",
    photo_title: "Kuva",
    photo_description: "Päivitä profiilikuvasi",
    upload_photo: "Lataa kuva",
    uploading_photo: "Ladataan...",
    remove_photo_aria: "Poista kuva",
    photo_hint: "JPG, PNG tai GIF. Enimmäiskoko 2MB.",
    personal_title: "Henkilökohtaiset tiedot",
    personal_description: "Päivitä henkilökohtaiset tietosi",
    first_name: "Etunimi",
    last_name: "Sukunimi",
    email_address: "Sähköpostiosoite",
    email_hint: "Vaihda sähköposti Asetukset > Turvallisuus.",
    phone_number: "Puhelinnumero",
    save_changes: "Tallenna muutokset",
    saving_changes: "Tallennetaan...",
    security_prompt: "Haluatko vaihtaa salasanan, hallita yhdistettyjä tilejä tai ottaa kaksivaiheisen tunnistautumisen käyttöön?",
    go_to_security: "Siirry turva-asetuksiin",
    toast_profile_updated: "Profiili päivitetty",
    toast_avatar_updated: "Avatar päivitetty",
    toast_avatar_removed: "Avatar poistettu",
    toast_security_navigation: "Siirry kohtaan Asetukset > Turvallisuus hallitaksesi turva-asetuksia",
    error_first_last_required: "Etunimi ja sukunimi ovat pakollisia.",
    error_profile_update: "Profiilia ei voitu päivittää.",
    error_avatar_upload: "Avatarin lataus epäonnistui.",
    error_avatar_remove: "Avatarin poisto epäonnistui.",
    error_avatar_process: "Avatarin käsittely epäonnistui.",
    error_image_type: "Valitse kuvatiedosto.",
    error_image_size: "Kuvan on oltava alle 2MB.",
    error_image_read: "Kuvan lukeminen epäonnistui.",
    crop_title: "Säädä kuvaa",
    crop_description: "Rajaa ja säädä kuvaa niin, että se sopii täydellisesti.",
    crop_zoom_label: "Zoom",
    crop_reset: "Palauta",
    crop_tip: "Vinkki: Käytä liukusäädintä zoomaukseen (10% - 500%). Vedä kuvaa siirtääksesi sitä. Kuva tallennetaan pyöreänä avatarina.",
    crop_cancel: "Peruuta",
    crop_apply: "Käytä",
    user_fallback: "Käyttäjä",
  },
};
